import { styled } from '@clickcease/cc-client-components-lib'

export const UserProfileSection = styled('div', {
  width: 'calc(100% -  60px)',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '30px',
  padding: '20px',
  background: '#ffffff',
  boxShadow: '0px 0px 30px rgba(102, 102, 102, 0.05)',
  minHeight: '137px',
  borderRadius: '12px',
})

export const UserProfilePage = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const FieldsWrapper = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',

  [' > div']: {
    margin: '20px 28px 0px 0px ',
  },
})

export const UserProfileError = styled('div', {
  width: '100%',
  fontSize: '$sm',
  color: 'red',
  marginTop: '20px',
  fontWeight: 'bold',
})
